"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAppIntegrations = void 0;

var getAppIntegrations = function getAppIntegrations(state) {
  return state.appIntegrations;
};

exports.getAppIntegrations = getAppIntegrations;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/appIntegrations.js
// module id = 697
// module chunks = 209 210 211 212